import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export type SaveKnowledgeObjectContentPayload = {
    readonly objectUid: string;
    readonly payload: readonly unknown[];
};

/**
 * Command to persist the canvas payload of a KnowledgeObject's
 * KnowledgeObjectContent (PRD-076). Mirrors the backend
 * `SaveKnowledgeObjectContentCommand` — the backend handler reads
 * `objectUid` (ShortId or UUID) and `payload` (BoardObject[]) from the payload.
 */
export class SaveKnowledgeObjectContentCommand extends AbstractCommand<SaveKnowledgeObjectContentPayload> {

    public name: CommandName = CommandName.SAVE_KNOWLEDGE_OBJECT_CONTENT;

    public tags = ['entity', 'update', 'knowledge-object'];

    constructor(payload: SaveKnowledgeObjectContentPayload) {
        super('knowledgeObject', payload.objectUid, payload);
    }

}
